import { CommonModule } from '@angular/common';
import { InjectionToken, NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, RouterModule, Routes } from '@angular/router';

import { AdminAuthGuard } from './security/guards/admin-auth-guard.service';
import { OfficeAuthGuard } from './security/guards/office-auth-guard.service';
import { ErrorComponent } from './shared/components/error/error.component';
import { LogoutCompleteComponent } from './security/components/logout-complete/logout-complete.component';
import { LogoutComponent } from './security/components/logout/logout.component';

export const externalUrlProvider = new InjectionToken('externalUrlRedirectResolver');

const sharedRoutes: Routes = [

    {
        path: 'staff',
        loadChildren: () => import('./staff/staff.module').then((m) => m.StaffModule),
        canActivate: [OfficeAuthGuard],
    },
    {
        path: 'documents',
        loadChildren: () => import('./documents/documents.module').then((m) => m.DocumentsModule),
        canActivate: [OfficeAuthGuard],
    },
    {
        path: 'documentCategories',
        loadChildren: () => import('./document-categories/document-categories.module').then((m) => m.DocumentCategoriesModule),
        canActivate: [OfficeAuthGuard],
    },
    {
        path: 'news',
        loadChildren: () => import('./news/news.module').then((m) => m.NewsModule),
        canActivate: [OfficeAuthGuard],
    },
    {
        path: 'assignmentSchedules',
        loadChildren: () => import('./assignment-schedules/assignment-schedules.module').then((m) => m.AssignmentSchedulesModule),
        canActivate: [OfficeAuthGuard],
    },
    {
        path: 'iconMappings',
        loadChildren: () => import('./icon-mappings/icon-mappings.module').then((m) => m.IconMappingsModule),
        canActivate: [AdminAuthGuard],
    },
    {
        path: 'error',
        component: ErrorComponent
    },
    {
        path: 'logout',
        component: LogoutComponent
    },
    {
        path: 'logout-complete',
        component: LogoutCompleteComponent
    },
    { path: '**', redirectTo: 'staff' }
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forRoot(sharedRoutes),
    ],
    providers: [
        {
            provide: externalUrlProvider,
            useValue: goToLink,
        },
    ],
    exports: [RouterModule],
})
export class AppRoutingModule { }

export function goToLink(route: ActivatedRouteSnapshot) {
    const externalUrl = route.paramMap.get('externalUrl')!;
    window.open(externalUrl, '_self');
}
